import {shippingAddressService} from '../services'

const state = {
    loading: false,
    customer: {},
}

const actions = {

    createCustomer({ dispatch, commit }, params) {
        commit('startCreateCustomerRequest')
        return shippingAddressService.createCustomer(params).then(
            response => {
                commit('successCreateCustomerRequest', response)
                return response
            },
            error => {
                commit('errorCreateCustomerRequest')
                dispatch('alert/error', 'Unable to create customer: ' + error, { root: true })
            }
        )
    },
    updateCustomerAddress({ dispatch, commit }, params) {
        commit('startCreateCustomerRequest')
        return shippingAddressService.updateCustomerAddress(params).then(
            response => {
                commit('successCreateCustomerRequest', response)
                return response
            },
            error => {
                commit('errorCreateCustomerRequest')
                dispatch('alert/error', 'Unable to update shipping address: ' + error, { root: true })
            }
        )
    },
    applyCustomerPromocode({ dispatch, commit }, params) {
        commit('startApplyCustomerPromocodeRequest')
        return shippingAddressService.applyCustomerPromocode(params).then(
            response => {
                commit('successApplyCustomerPromocodeRequest', response)
                return response
            },
            error => {
                commit('errorApplyCustomerPromocodeRequest')
                dispatch('alert/error', error, { root: true })
            }
        )
    },
}

const mutations = {
    startCreateCustomerRequest (state) {
        state.loading = true
        state.customer = {}
    },
    successCreateCustomerRequest (state, response) {
        state.loading = false
        state.customer = response.customer
    },
    errorCreateCustomerRequest (state) {
        state.loading = false
        state.customer = {}
    },
    startApplyCustomerPromocodeRequest (state) {
        state.loading = true
    },
    successApplyCustomerPromocodeRequest (state, response) {
        state.loading = false
    },
    errorApplyCustomerPromocodeRequest (state) {
        state.loading = false
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    },
    getCustomer(state) {
        return state.customer;
    },
}

export const shippingAddressModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
